import { connect } from 'react-redux';
import { isInstructorInSpace } from '@core/selectors/classroom';
import {
  currentUserId as getCurrentUserId,
  accessToken as getAccessToken,
  currentUser,
} from '@core/selectors/user';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';
import AulaEditorWithAnalytics from '@components/presentational/common/AulaEditor/AulaEditorWithAnalytics';
import AulaEditorWithAnalyticsWithoutPlugins from '@components/presentational/common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import CreateComment from '@components/presentational/Comments/CreateComment/CreateComment';
import EditorReadOnly from '@components/presentational/common/EditorPlus/EditorReadOnly';

const mapCreateCommentStateToProps = (state: any, ownProps: any) => {
  const { spaceId } = ownProps;
  const userId = getCurrentUserId(state);
  const isEducator = isInstructorInSpace(state)(userId, spaceId);

  return {
    user: state.user.user,
    isCreatingComment: state.comment.isCreatingComment,
    spaceId,
    isEducator,
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    ltiProviders: getMaterialPlacementLtiProviders(state),
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
  };
};

export const HomeCreateComment = connect(mapCreateCommentStateToProps)(
  CreateComment
);

// --- HomeEditorReadOnly ---
// Injects spaceId from own props instead of reading state.classRoom.current.
const mapEditorReadOnlyStateToProps = (state: any, ownProps: any) => {
  const { spaceId } = ownProps;
  const user = currentUser(state);
  const userId = state.user?.userId;
  const isEducator = isInstructorInSpace(state)(userId, spaceId);

  return {
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    spaceId,
    user,
    isEducator,
    ltiProviders: getMaterialPlacementLtiProviders(state),
  };
};

export const HomeEditorReadOnly = connect(mapEditorReadOnlyStateToProps)(
  EditorReadOnly
);
